const USE_LOCATION_KEY = "USE_LOCATION";

export function storeUseLocationPreference(useLocation) {
    localStorage.setItem(USE_LOCATION_KEY, JSON.stringify(useLocation));
}

export function loadUseLocationPreference() {
    const useLocation = localStorage.getItem(USE_LOCATION_KEY);
    return useLocation == null ? false : JSON.parse(useLocation);
}